import load from "little-loader";
import qs from "query-string";

var GOOGLE_MAP_PLACES_API = "https://maps.googleapis.com/maps/api/js";
var NOT_LOADED = 0;
var LOADING = 1;
var LOADED = 2;

var queue = [];
var state = NOT_LOADED;
var googleMaps = null;
var error = null;

function loadGoogleMapsSdk(params, callback) {
  if (typeof window !== "undefined") {
    window.gm_authFailure = function () {
      callback({ googleMaps: googleMaps, error: "SDK Authentication Error" });
    };

    if (state === LOADED) {
      callback({ googleMaps: googleMaps, error: error });
    } else if (state === LOADING) {
      queue.push(callback);
    } else {
      if (!window.google) {
        window.google = undefined;
      }

      state = LOADING;
      queue.push(callback);

      load(GOOGLE_MAP_PLACES_API + "?" + qs.stringify(params), function (err) {
        state = LOADED;
        error = err ? "Network Error" : null;
        googleMaps = window.google ? window.google.maps : null;

        while (queue.length > 0) {
          queue.pop()({ googleMaps: googleMaps, error: error });
        }
      });
    }
  }
}

export default loadGoogleMapsSdk;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-maps-loader/es/loadGoogleMapsSdk/index.js
// module id = 1406
// module chunks = 0